/* clad-currency.js · 2026-10-15
   Currency picker. The store sells in USD only and card payments run through Airwallex, so checkout always charges
   USD. Any other currency is shown as an estimate at Shopify's daily rate: a note sits under the product price and
   above every checkout button, and the checkout buttons themselves keep the USD amount ("US$55.25").
   The list covers the currencies of the countries the store ships to (US, Australia, UK, the EU).
   How it works: every text node that holds a "$12.34" amount is rewritten in place and its original text is kept, so
   switching back restores the exact USD wording. A MutationObserver converts prices that clad.js renders later
   (variant and pack changes, the bag drawer, the free-shipping bar). Nothing is converted for USD visitors.
   Trigger buttons live in sections/header.liquid ([data-cur-btn]); styles are the .cur-* rules in clad.css.liquid.
   Flags and rates both come from Shopify's CDN. */
(function () {
  'use strict';
  var KEY = 'clad_cur', RKEY = 'clad_rates';
  var RATES_URL = 'https://cdn.shopify.com/s/javascripts/currencies.js';
  var FLAG = 'https://cdn.shopify.com/static/images/flags/';
  var FRESH = 12 * 3600e3, USABLE = 7 * 24 * 3600e3;
  var LIST = [
    { c: 'USD', f: 'us', n: 'US dollar', s: '$' },
    { c: 'AUD', f: 'au', n: 'Australian dollar', s: 'A$' },
    { c: 'GBP', f: 'gb', n: 'British pound', s: '£' },
    { c: 'EUR', f: 'eu', n: 'Euro', s: '€' },
    { c: 'DKK', f: 'dk', n: 'Danish krone', s: 'DKK ' },
    { c: 'SEK', f: 'se', n: 'Swedish krona', s: 'SEK ' },
    { c: 'PLN', f: 'pl', n: 'Polish złoty', s: 'PLN ' },
    { c: 'CZK', f: 'cz', n: 'Czech koruna', s: 'CZK ' },
    { c: 'HUF', f: 'hu', n: 'Hungarian forint', s: 'HUF ' },
    { c: 'RON', f: 'ro', n: 'Romanian leu', s: 'RON ' }
  ];
  var BY = {}; LIST.forEach(function (x) { BY[x.c] = x; });
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 };
  var KEEP = '[data-checkout], button[name="checkout"], [data-cur-keep]';
  var RE = /(^|[^A-Za-z0-9])\$(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{1,2}))?(?!\d)/g;

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function put(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  var mode = BY[get(KEY)] ? get(KEY) : 'USD';
  var rates = null;
  try { var cached = JSON.parse(get(RKEY) || 'null'); if (cached && cached.r && Date.now() - cached.t < USABLE) rates = cached; } catch (e) {}
  function cur() { return mode !== 'USD' && rates && rates.r[mode] ? mode : 'USD'; }

  /* ---------- text conversion */
  var orig = new WeakMap(), tracked = new Set();
  function convert(text, keep) {
    var c = cur();
    return text.replace(RE, function (m, pre, whole, cents) {
      if (keep) return pre + 'US$' + whole + (cents ? '.' + cents : '');
      var usd = parseFloat(whole.replace(/,/g, '') + '.' + (cents || '0'));
      return pre + BY[c].s + Math.round(usd * rates.r[c]).toLocaleString('en-US');
    });
  }
  function handle(node) {
    var rec = orig.get(node), now = node.nodeValue;
    if (rec && now === rec.shown) return;                                 /* our own write */
    if (rec) { orig.delete(node); tracked.delete(node); }                 /* the page put new text here */
    if (!now || now.indexOf('$') < 0) return;
    var p = node.parentNode;
    if (!p || p.nodeType !== 1 || SKIP[p.nodeName] || p.closest('[data-cur-skip]')) return;
    var shown = convert(now, !!p.closest(KEEP));
    if (shown === now) return;
    orig.set(node, { o: now, shown: shown }); tracked.add(node);
    node.nodeValue = shown;
  }
  function walk(root) {
    if (root.nodeType === 3) return handle(root);
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) if (n.nodeValue.indexOf('$') >= 0) list.push(n);
    list.forEach(handle);
  }
  function restore() {
    tracked.forEach(function (n) { var r = orig.get(n); if (r && n.nodeValue === r.shown) n.nodeValue = r.o; orig.delete(n); });
    tracked.clear();
  }

  /* ---------- prices rendered later */
  var mo = null;
  function observe(want) {
    if (want && !mo && window.MutationObserver) {
      mo = new MutationObserver(function (ms) {
        ms.forEach(function (m) {
          if (m.type === 'characterData') handle(m.target);
          else each(m.addedNodes, walk);
        });
        notes();
      });
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    } else if (!want && mo) { mo.disconnect(); mo = null; }
  }

  /* ---------- notes next to the product price and above checkout */
  function noteText() { return 'Prices in ' + cur() + ' are estimates at today’s rate. You’ll be charged in USD at checkout.'; }
  function inFixed(el) {
    for (var a = el; a && a !== document.body; a = a.parentElement) if (getComputedStyle(a).position === 'fixed') return true;
    return false;
  }
  function noteEl(extra) {
    var p = document.createElement('p');
    p.setAttribute('data-cur-note', '');
    p.textContent = noteText();
    p.style.cssText = 'font-size:12px;line-height:1.5;color:#8A8178;margin:8px 0;' + (extra || '');
    return p;
  }
  function notes() {
    if (cur() === 'USD') {
      each(document.querySelectorAll('[data-cur-note]'), function (n) { n.remove(); });
      each(document.querySelectorAll('[data-cur-noted]'), function (e) { e.removeAttribute('data-cur-noted'); });
      return;
    }
    var t = noteText();
    each(document.querySelectorAll('[data-cur-note]'), function (n) { if (n.textContent !== t) n.textContent = t; });
    each(document.querySelectorAll(KEEP), function (b) {
      if (b.hasAttribute('data-cur-noted') || !b.parentNode) return;
      b.setAttribute('data-cur-noted', '');
      b.parentNode.insertBefore(noteEl('text-align:center'), b);
    });
    each(document.querySelectorAll('[data-price]'), function (p) {   /* the price beside the product title, not the one in the button */
      if (p.closest('a,button')) return;
      if (p.closest('[data-cur-nonote]')) return;                      /* the phone product page (2026-10-16): the cart's note above checkout says it */
      var row = p.parentElement;
      if (!row || row.hasAttribute('data-cur-noted')) return;
      row.setAttribute('data-cur-noted', '');
      if (inFixed(row)) return;                                        /* the phone's sticky add-to-bag bar has no room */
      row.insertAdjacentElement('afterend', noteEl('margin:6px 0 0'));
    });
  }

  /* ---------- trigger buttons */
  function paint() {
    var c = cur();
    each(document.querySelectorAll('[data-cur-btn]'), function (b) {
      var img = b.querySelector('[data-cur-flag]'), code = b.querySelector('[data-cur-code]');
      if (img && img.getAttribute('src') !== FLAG + BY[c].f + '.svg') img.setAttribute('src', FLAG + BY[c].f + '.svg');
      if (code) code.textContent = c;
      b.setAttribute('aria-label', 'Currency: ' + c + '. Change currency');
    });
    document.documentElement.setAttribute('data-currency', c);
  }
  function apply() {
    observe(false);
    restore();
    if (cur() !== 'USD') { walk(document.body); observe(true); }
    notes();
    paint();
  }
  function loadRates(done) {
    if (!window.fetch) { if (done) done(); return; }
    fetch(RATES_URL, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var pick = function (c) { var m = new RegExp('(?:^|[^A-Z])' + c + ':\\s*([0-9.eE+-]+)').exec(t); return m ? parseFloat(m[1]) : 0; };
        var usd = pick('USD'), r = {};
        if (usd > 0) LIST.forEach(function (x) { var v = pick(x.c); if (v > 0) r[x.c] = usd / v; });
        if (r.AUD > 0.5 && r.AUD < 5) { rates = { r: r, t: Date.now() }; put(RKEY, JSON.stringify(rates)); }
      })
      .catch(function () {})
      .then(function () { if (done) done(); });
  }
  function setMode(c) {
    mode = c; put(KEY, c);
    if (c !== 'USD' && !(rates && rates.r[c])) loadRates(apply); else apply();
  }

  /* ---------- the list that opens from a trigger */
  var panel = null, opener = null;
  function buildPanel() {
    var el = document.createElement('div');
    el.className = 'cur-panel';
    el.setAttribute('role', 'listbox');
    el.setAttribute('aria-label', 'Choose a currency');
    el.setAttribute('data-cur-skip', '');
    var c = cur(), html = '';
    LIST.forEach(function (x) {
      html += '<button type="button" role="option" data-cur-pick="' + x.c + '" aria-selected="' + (x.c === c) + '">' +
        '<img src="' + FLAG + x.f + '.svg" alt="" width="20" height="15"><b>' + x.c + '</b><span>' + x.n + '</span><i>' + (x.c === c ? '✓' : '') + '</i></button>';
    });
    el.innerHTML = html + '<p>Checkout is in US dollars. Other currencies are estimates at today’s rate.</p>';
    return el;
  }
  function place() {
    if (!panel || !opener) return;
    var r = opener.getBoundingClientRect(), vw = document.documentElement.clientWidth;
    panel.style.top = Math.round(r.bottom + 8) + 'px';
    panel.style.right = Math.max(12, Math.round(vw - r.right)) + 'px';
  }
  function open(btn) {
    close();
    opener = btn; panel = buildPanel();
    document.body.appendChild(panel);
    place();
    btn.setAttribute('aria-expanded', 'true');
    var sel = panel.querySelector('[aria-selected="true"]') || panel.querySelector('button');
    if (sel) sel.focus({ preventScroll: true });
  }
  function close(refocus) {
    if (panel) { panel.remove(); panel = null; }
    if (opener) { opener.setAttribute('aria-expanded', 'false'); if (refocus) opener.focus({ preventScroll: true }); opener = null; }
  }

  var warmed = false;
  function warm() {                                                   /* fetch the ten flags as soon as a hand nears the button */
    if (warmed) return; warmed = true;
    LIST.forEach(function (x) { var i = new Image(); i.src = FLAG + x.f + '.svg'; });
    if (!rates || Date.now() - rates.t > FRESH) loadRates();
  }

  function init() {
    ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('[data-cur-btn]')) warm(); }, { passive: true });
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var pick = t.closest('[data-cur-pick]');
      if (pick) { e.preventDefault(); var c = pick.getAttribute('data-cur-pick'); close(true); if (c !== cur()) setMode(c); return; }
      var btn = t.closest('[data-cur-btn]');
      if (btn) { e.preventDefault(); if (panel && opener === btn) close(); else open(btn); return; }
      if (panel && !panel.contains(t)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!panel) return;
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var opts = Array.prototype.slice.call(panel.querySelectorAll('[data-cur-pick]'));
        var i = opts.indexOf(document.activeElement);
        i = e.key === 'ArrowDown' ? Math.min(opts.length - 1, i + 1) : Math.max(0, i - 1);
        opts[i].focus();
      }
    });
    window.addEventListener('resize', function () { close(); });
    window.addEventListener('scroll', function () { if (panel) close(); }, { passive: true });
    apply();
    if (mode !== 'USD' && (!rates || !rates.r[mode] || Date.now() - rates.t > FRESH)) loadRates(apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
